import { render } from "./DetailComp.vue?vue&type=template&id=a74bc060"
import script from "./DetailComp.vue?vue&type=script&lang=js"
export * from "./DetailComp.vue?vue&type=script&lang=js"

import "./DetailComp.vue?vue&type=style&index=0&id=a74bc060&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__